import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "mr-2 toggle__label"
}
const _hoisted_3 = {
  key: 0,
  class: "toggle__label-bold"
}
const _hoisted_4 = { class: "toggle__switch" }
const _hoisted_5 = ["id", "name", "checked"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "toggle__slider round" }, null, -1 /* HOISTED */)
const _hoisted_7 = {
  key: 1,
  class: "ml-2 toggle__label"
}
const _hoisted_8 = {
  key: 0,
  class: "toggle__label-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toggle", { 'label-right': $props.labelAlignment === 'right' }])
  }, [
    _createElementVNode("label", {
      for: $props.id,
      class: "toggle__wrapper"
    }, [
      ($props.labelAlignment === 'left')
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createTextVNode(_toDisplayString($data.switchLabel) + " ", 1 /* TEXT */),
            (!$props.hideToggleLabel)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($data.toggleLabel), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("input", {
          type: "checkbox",
          value: "ON",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.onSwitchChange && $options.onSwitchChange(...args))),
          id: $props.id,
          name: $props.id,
          checked: $data.isToggled
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5),
        _hoisted_6
      ]),
      ($props.labelAlignment === 'right')
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
            _createTextVNode(_toDisplayString($data.switchLabel), 1 /* TEXT */),
            (!$props.hideToggleLabel)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($data.toggleLabel), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ], 8 /* PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}